/**
 * Restauration silencieuse de la session au chargement (docs/06 §9).
 *
 * L'access token vit en mémoire : il disparaît à chaque rechargement de page.
 * Le refresh token, lui, est un cookie `HttpOnly` qui survit. Une tentative de
 * rotation au démarrage suffit donc à retrouver la session — sans jamais avoir
 * eu à stocker quoi que ce soit de sensible côté JavaScript.
 */
import { useEffect, useRef, type ReactNode } from "react";

import { refreshSession, useSessionStore } from "@/shared/auth/session";

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const status = useSessionStore((state) => state.status);
  const attempted = useRef(false);

  useEffect(() => {
    // En mode strict, React monte les effets deux fois en développement : sans
    // ce garde, deux rotations concurrentes partiraient au démarrage et la
    // seconde serait vue par l'API comme un rejeu.
    if (attempted.current || status !== "unknown") {
      return;
    }
    attempted.current = true;
    void refreshSession();
  }, [status]);

  return <>{children}</>;
}
